<template>
  <div>
    <h1 class="display-1 font-weight-bold mx-1 mb-3">Board : {{ board?.board.name }}</h1>
    <v-btn @click="newCardDialog()">New Artwork Card</v-btn>
    <card-dialog
      v-if="openDialog"
      v-model="openDialog"
      :board="board"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import TrelloApi from "@/api/admin/trello";
import ContactApi from "@/api/contact";
import CardDialog from "./components/CardDialog.vue";
export default {
  components: {
    CardDialog,
  },
  data() {
    return {
      selectedFile: null,
      board: null,
      openDialog: false,
    };
  },
  async created() {
    const boardId = this.$route.params.boardId;
    TrelloApi.getBoard(boardId).then((board) => (this.board = board.data));
    TrelloApi.getBoardLists(boardId).then((boardLists) => (this.boardLists = boardLists));
  },
  methods: {
    newCardDialog() {
      console.log(this.openDialog);
      this.openDialog = true;
    },
    closeDialog(evt) {
      this.openDialog = false;
    },
  },

  computed: {},
  watch: {},
};
</script>
